var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/rail"}},[_vm._v("电子围栏")])],1),_c('div',{staticClass:"main"},[_c('keep-alive',[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }